// Re-export the shared LocationInput component for backwards compatibility
export { LocationInput } from "@shared/components/LocationInput";
export type { LocationData } from "@shared/components/LocationInput";
